import axios from 'axios';

const { REACT_APP_API_GATEWAY_URL } = process.env;

export const getCourseActivityDetails = async (userId, productId) => {
  const params = new URLSearchParams({
    userId,
    productId,
  });
  const userIdFromParams = params.get('userId');
  const productIdFromParams = params.get('productId');

  return axios.get(`${REACT_APP_API_GATEWAY_URL}/users/${userIdFromParams}/products/${productIdFromParams}/course-activities`, {
    headers: { scope: 'read:course_activities' },
  });
};

export const setCourseActivity = async ({ productId, contentId, status }) => {
  const params = new URLSearchParams({
    productId,
  });
  const productIdFromParams = params.get('productId');
  return axios.put(`${REACT_APP_API_GATEWAY_URL}/products/${productIdFromParams}/course-activities`, {
    contentId,
    status,
  },
  { headers: { scope: 'update:course_activities' } });
};

export const resetLaeExpiryDate = async ({ productId, contentId, resetExpiryDate }) => {
  const params = new URLSearchParams({
    productId,
  });
  const productIdFromParams = params.get('productId');

  return axios.put(`${REACT_APP_API_GATEWAY_URL}/products/${productIdFromParams}/course-activities`, {
    contentId,
    resetExpiryDate,
  },
  { headers: { scope: 'update:course_activities' } });
};

export const updateExpireDate = async ({ data }) => axios.put(`${REACT_APP_API_GATEWAY_URL}/customers/course-seats`, data,
  { headers: { scope: 'update:course_seats' } });
